import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const DataManagementPage = lazy(() => import('./DataManagementPage'));

const DataManagementAppConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/settings/personal-data',
			element: <DataManagementPage />
		}
	]
};
export default DataManagementAppConfig;
